import React from 'react';
import './styles.css';
import HomeScreen from '../homescreen/homescreen'

class GalleryViewer extends HomeScreen {

    state = {
        imageNotFound: false,
        imgSource: null
    };

    queryParams = new URLSearchParams(window.location.search);

    componentDidMount() {
        let imgSource = this.queryParams.get('photo');
        if (imgSource.indexOf('http') != 0) {
            imgSource = `https://condemakoto.com/${imgSource}`
        }
        this.state.imgSource = imgSource;
        this.setState(this.state);
    }

    renderHomeContent() {
        const {imgSource} = this.state;
        return (
            <div>
                <img src={imgSource} className='gallery_viewer_img'/>
            </div>
        );
    }

    getScreenName() {
        return 'Gallery viewer';
    }

}

export default GalleryViewer;


// WEBPACK FOOTER //
// ./src/screens/gallery_viewer/index.js